import React from 'react';
import BaseFactory from './BaseFactory';
import {
  getFaqsAnchorTag,
  getBlogAnchorTag,
  NoTopMarginParagraph,
  NoBottomMarginParagraph,
  getWalkInClinicAnchorTag,
  hasCustomDescription,
} from './util';
import CustomDescriptionSection from './CustomDescriptionSection';
import { SOLV_SECTION_TITLE } from './constants';

class NonPartnerEmergencyRoom extends BaseFactory {
  getDescription() {
    return (
      `${this.clinicName} is an emergency room ` +
      `located at ${this.address}, ${this.city}, ` +
      `${this.state}, ${this.zip} and provides general, family medical care including ` +
      'preventative care, physicals, chronic condition treatment and more. For more ' +
      `information, call ${this.clinicName}${this.phoneString}.`
    );
  }

  getKeywords() {
    return (
      `${this.clinicName}, ${this.clinicName}, ${this.city}, ${this.clinicName} ${this.zip}, ` +
      `emergency room ${this.city}, emergency room ${this.zip}, ` +
      `er ${this.city}, er ${this.zip}, hospital ${this.city}, hospital ${this.zip} ` +
      `${this.city} ${this.state} hospital er, ${this.zip} hospital er`
    );
  }

  getBody() {
    return (
      <span>
        <CustomDescriptionSection location={this.location} />
        <NoTopMarginParagraph>
          {hasCustomDescription(this.location) && (
            <span>
              {SOLV_SECTION_TITLE}
              <br />
            </span>
          )}
          <b>If you are experiencing a medical emergency, call 911 immediately.</b>{' '}
          {this.clinicName} is an emergency room, commonly called an E.R., providing critical and
          life saving healthcare services to patients throughout the {this.cityAnchorTag} area
          through their location at {this.fullAddress}. They are required by law to be open 24 hours
          a day, 7 days a week, even on national holidays like Thanksgiving and Christmas.
        </NoTopMarginParagraph>
        <p>
          While their availability can be enticing, you should really only visit an E.R. if you
          absolutely have to as they can be quite expensive and have much longer wait times than an{' '}
          {getWalkInClinicAnchorTag()} center. In fact, some insurance carriers have begun to refuse
          paying for emergency room visits that were in fact non-emergent. An interesting fact that
          about 50% of emergency room diagnosis could be addressed at a quicker, less expensive
          urgent care center.
        </p>
        <NoBottomMarginParagraph>
          If you are looking to learn more about emergency rooms and when (and when not) to visit
          one, statistics, trends, {getFaqsAnchorTag()} and other useful information, check out our{' '}
          {getBlogAnchorTag()} to empower your knowledge as a healthcare consumer.{' '}
          {this.cityGuideContent}
        </NoBottomMarginParagraph>
      </span>
    );
  }
}

export default NonPartnerEmergencyRoom;
